import { render, staticRenderFns } from "./DashboardColumn.vue?vue&type=template&id=cec96aa0"
import script from "./DashboardColumn.vue?vue&type=script&lang=js"
export * from "./DashboardColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports